import React from "react";
import { DropdownItem } from "reactstrap";
import style from "./../style.module.scss";
import { IconClass } from "../UI";
import { Datetime } from "../Grid/Grid";
import { CustomHandlers } from "../types";
import { FormattedDate, FormattedTime } from "react-intl";
import { localDateTime } from "../../../utils/Helper";

const Item = ({ item, tag, route, onClick }) => {
  const redirectProps = CustomHandlers.includes(item.process)
    ? {}
    : {
        tag,
        replace: true,
        to: {
          pathname: route,
          state: {
            id: item.processId,
            hash: Math.random().toString(36).substring(2, 10),
          },
        },
      };

  const cleanText = item.text.replace(/#Failed#|#Success#/g, "").trim();
  const isFailed = item.process === "Offer" && !item.read && item.text.includes("#Failed#");
  const backgroundColor = isFailed
  ? "#f8d7da"
  : "";

  return (
    <DropdownItem {...redirectProps} onClick={(e) => onClick(e)} className={style.item} style={{ backgroundColor }} >
      <i className={`${IconClass(item.process)} text-primary`}></i>
      <div className={style.body}>
        <div className={style.top}>
          <span>{item.process}</span>
          <span className="text-muted">
          <FormattedDate value={localDateTime(item.dateTime)} />{" "}
          <FormattedTime value={localDateTime(item.dateTime)} hour12={false} />
          </span>
        </div>
        <p>{cleanText}</p>
      </div>
    </DropdownItem>
  );
};

export default Item;
